import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/chk_cpf";
import { ICpf } from "interfaces/chk_cpf";

const { Types, Creators } = createActions(
  {
    request: ["cpf", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CHK_CPF" }
);

export interface iChkCpf extends IState {
  data: ICpf[];
}

interface ISuccessChkCpfAction extends ISuccessAction {
  data: ICpf[];
}

const INITIAL_STATE: iChkCpf = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: iChkCpf) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: iChkCpf, action: ISuccessChkCpfAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: iChkCpf, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const chkcpf = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ChkCpfTypes = Types;
export const ChkCpfActions = Creators;
